
export default function initials(firstName: string, lastName: string): string {

    return (
        (firstName.trim().substring(0,1) || '') + 
        (lastName.trim().substring(0,1) || '')
    ).toUpperCase()
}